import { PropTypes } from "prop-types";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import { withALErrorBoundary } from "../../helpers/ErrorBoundary/ALErrorBoundary";
import { Link } from "../al_components/ALLink";
import useResponsiveWithHydrationFix from "../../hooks/useResponsiveWithHydrationFix";
import RichTextContentful from "../RichTextContentful";

import * as Styles from "./textAndImages/styles.module.scss";

function TextAndImagesImage({ image }) {
  const imageUrl = useResponsiveWithHydrationFix(
    getImage(image.mobileImage?.gatsbyImageData),
    getImage(image.desktopImage.gatsbyImageData)
  );

  return <GatsbyImage image={imageUrl} alt={image?.altText} key={`image-${image.id}`} />;
}

function TextAndImages({ content }) {
  return (
    <div className={Styles.content} style={{ backgroundColor: content.backgroundColor }}>
      <div className={Styles.text_wrapper}>
        <h2 className="h2 h2--bold pb-[20px] m-0">{content.title}</h2>
        {content.description?.raw && (
          <RichTextContentful input={content.description?.raw} prefixClassName="lp" />
        )}
      </div>

      <div className={Styles.images_wrapper}>
        {content.images.map((image, i) =>
          image?.link?.title === "empty" || image?.link?.title === "null" ? (
            <TextAndImagesImage key={`image-${i}`} image={image} />
          ) : (
            <Link to={image?.link?.link?.link} key={`image-${i}`}>
              <TextAndImagesImage image={image} />
            </Link>
          )
        )}
      </div>
    </div>
  );
}

TextAndImages.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.shape({
      raw: PropTypes.string,
    }),
    images: PropTypes.arrayOf(
      PropTypes.shape({
        altText: PropTypes.string,
      })
    ).isRequired,
    backgroundColor: PropTypes.string,
  }),
};

export default withALErrorBoundary({
  name: "TextAndImages",
  priority: "P2",
})(TextAndImages);
